<template>
  <div>
    <el-form :model="query" ref="queryForm" :inline="true">
      <el-form-item label="登录状态：">
        <el-select v-model="query.isLonginged" placeholder="请选择" clearable size="small">
          <el-option label="已登录" :value="1"></el-option>
          <el-option label="未登录" :value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="所属区域：">
        <el-cascader v-model="query.addrid" :props="cascaderProps" collapse-tags :options="addressList" :show-all-levels="false" clearable placeholder="请选择所属区域" size="small"></el-cascader>
      </el-form-item>
      <el-form-item label="业务归属：">
        <el-select v-model="query.parentId" filterable placeholder="请选择业务员" clearable size="small" :filter-method="businessFilter" @blur="getBusinessList()">
          <el-option :label="`${item.name}（${item.levelName}）${item.pho}`" :value="item.id" v-for="item in businessList" :key="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="大区归属：">
        <el-select v-model="query.areaId" filterable placeholder="请选择" clearable size="small" :filter-method="technicianFilter" @blur="getTechnicianList()">
          <el-option :label="`${item.name}（${item.levelName}）${item.pho}`" :value="item.id" v-for="item in technicianList" :key="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="所属城市公司：">
        <el-select v-model="query.cityCompanyId" filterable placeholder="请选择所属城市公司" clearable size="small">
          <el-option :label="item.value" :value="item.key" v-for="item in companyList" :key="item.key"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="身份：">
        <el-select v-model="query.clevel" placeholder="请选择" clearable size="small">
          <el-option :label="item.name" :value="item.level" v-for="item in standingList" :key="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="加入时间：">
        <el-date-picker v-model="dateTime" size="small" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleDownload" size="mini">导出</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import clientListApi from '@/api/client/clientList'
import customerLevelApi from '@/api/sys/customerLevel'
import cityCompanyApi from '@/api/sys/cityCompany'
import technicianInfoApi from '@/api/technical/technicianInfo'

export default {
  data() {
    return {
      cascaderProps: {
        label: 'regionName',
        value: 'regionCode',
        children: 'child',
        checkStrictly: true
      },
      dateTime: [],
      list: [],
      total: 0,
      listLoading: true,
      query: {
      },
      standingList: [],
      technicianList: [],
      businessList: [],
      companyList: []
    }
  },
  created() {
    let regionOptions = JSON.parse(localStorage.getItem('addressTree')) || [];
    this.addressList = this.formatCascaderData(regionOptions)
    this.getStandingList()
    this.getOptionList()
    this.getBusinessList()
    this.getTechnicianList()
  },
  methods: {
    businessFilter(e) {
      this.getBusinessList(e)

    },
    technicianFilter(e) {
      this.getTechnicianList(e)
    },
    // 获取大区列表
    getTechnicianList(e) {
      let obj = {
        customerTypes: 2,
        isGetAllParent: true,
        isDeparted: 0,
        cLevel: 3,
        pageNo: 1,
        pageSize: 100
      }
      if (e) obj.name = e
      clientListApi.getListPageForMini(obj).then(({ data }) => {
        this.technicianList = data.list
      })
    },
    // 获取城市公司
    getOptionList() {
      cityCompanyApi.getOption().then(({ data }) => {
        this.companyList = data
      })
    },
    // 获取业务员列表
    getBusinessList(e) {
      let obj = {
        customerTypes: 2,
        isGetAllParent: true,
        isDeparted: 0,
        pageNo: 1,
        pageSize: 100
      }
      if (e) obj.name = e
      clientListApi.getListPageForMini(obj).then(({ data }) => {
        this.businessList = data.list
      })
    },
    formatCascaderData(data) {
      for (var i = 0; i < data.length; i++) {
        if (data[i].child.length < 1) {
          // children若为空数组，则将children设为undefined
          data[i].child = undefined;
        } else {
          // children若不为空数组，则继续 递归调用 本方法
          this.formatCascaderData(data[i].child)
        }
      }
      return data
    },
    // 获取客户身份
    getStandingList() {
      customerLevelApi.fetchList({ type: 3 }).then(({ data }) => {
        this.standingList = data
      })
    },
    handleDownload() {
      let query = { ...this.query, customerType: 3 }
      query.startTime = this.dateTime && this.dateTime.length > 0 ? this.dateTime[0] : ""
      query.endTime = this.dateTime && this.dateTime.length > 0 ? this.dateTime[1] : ""
      if (this.query.addrid && this.query.addrid.length > 0) {
        query.addrid = this.query.addrid[this.query.addrid.length - 1]
      }
      return this.$common.confirm('是否确认导出')
        .then(() => clientListApi.exportExcels(query)).then((res) => {
          if (res.code === '0') {
            setTimeout(() => {
              this.$emit('created')
            }, 1000)
          }
        })
    },

  }

}
</script>

<style>
</style>
